import _ from 'lodash';

/**
 * Created by or_p on 3/18/2017.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import * as Colors from 'material-ui/styles/colors';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem, makeSelectable} from 'material-ui/List';
import {TOP_LEVEL_MENU_HEIGHT, TOP_LEVEL_MENU_WIDTH, LEFT_BAR_ACTIVE_COLOR} from '../TwoLevelesMenuStyle';
import CustomSvgIcon from 'crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIcon';
import shallowEqual from 'fbjs/lib/shallowEqual';

const styles = {
  root: {
    minWidth: TOP_LEVEL_MENU_WIDTH,
    width: TOP_LEVEL_MENU_WIDTH,
    height: TOP_LEVEL_MENU_HEIGHT,
    // boxSizing: 'content-box',
    borderRight: `4px solid ${Colors.transparent}`,
    borderRadius: 0,
  },
  innerDiv: {
    lineHeight: '14px',
    fontSize: 14,
    height: TOP_LEVEL_MENU_HEIGHT - 37,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
  }
};

export default class TopLevelMenuElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(_.omit(this.props, 'onClick'), _.omit(nextProps, 'onClick'));
  }

  render() {
    const {icon, label, selected, ...props} = this.props;
    const textColor = selected ? Colors.grey700 : Colors.white;
    const rootStyle = {
      ...styles.root,
      borderLeft: `4px solid ${selected ? Colors.lightGreen700 : Colors.transparent}`,
      color: textColor,
    };
    if (selected) {
      rootStyle.backgroundColor = LEFT_BAR_ACTIVE_COLOR;
    }
    return (
      <FlatButton style={rootStyle} {...props}>
        <div style={styles.innerDiv}>
          <CustomSvgIcon
            path={icon}
            color={textColor}
          />
          {label}
        </div>
      </FlatButton>
    );
  }
}

TopLevelMenuElement.contextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

TopLevelMenuElement.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node,
  style: PropTypes.object,
};